import { render, staticRenderFns } from "./InfoItem.vue?vue&type=template&id=6555d9e6"
import script from "./InfoItem.vue?vue&type=script&lang=ts"
export * from "./InfoItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6555d9e6')) {
      api.createRecord('6555d9e6', component.options)
    } else {
      api.reload('6555d9e6', component.options)
    }
    module.hot.accept("./InfoItem.vue?vue&type=template&id=6555d9e6", function () {
      api.rerender('6555d9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/InfoItem/InfoItem.vue"
export default component.exports